webpackJsonp([157072593749239],{

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Features = __webpack_require__(20);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _Video = __webpack_require__(15);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Features2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Visual Cues'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Useful for providing the user with a visual indication that some action is being performed but has no yet completed. Examples include fetching, updating and creating data.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visualization'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This video demonstrates what visual cues look like. Screenshots are from the ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'Simply Social'
	      ),
	      ' prototype that ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.invisionapp.com/' },
	        'Invision'
	      ),
	      ' provides you when you sign up for an account.'
	    ),
	    _react2.default.createElement(_Video2.default, { videoId: '6uJ7Y6p7eBU' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section demonstrates how to ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'use'
	      ),
	      ' the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/features/data-structure/' },
	        'data structure provided by Lore'
	      ),
	      ' so please read that first if you\'re unfamiliar with the data structure.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Data can go through a lot of different states during the lifecycle of an application. Lore calls these states',
	      _react2.default.createElement(
	        'code',
	        null,
	        'PayloadStates'
	      ),
	      ', after the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'payload'
	      ),
	      ' field in the actions dispatched to the Redux store, and accounts for the following scenarios by default:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Data being fetched'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Data being created'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Data being updated'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Data being deleted'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'It also accounts for error conditions on each of those scenarios:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Error while fetching data'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Error while creating data'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Error while updating data'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Error while deleting data'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'And finally it accounts for the scenario where ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'nothing'
	      ),
	      ' is happening to data, after the transient state has been resolved. All of these scenarios are represented as constants in a file called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'PayloadStates'
	      ),
	      ' at',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/constants/PayloadStates.js'
	      ),
	      ' in your project. That file looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      PayloadStates = {\n        RESOLVED: \'RESOLVED\',\n\n        CREATING: \'CREATING\',\n        UPDATING: \'UPDATING\',\n        DELETING: \'DELETING\',\n        FETCHING: \'FETCHING\',\n\n        ERROR_CREATING: \'ERROR_CREATING\',\n        ERROR_UPDATING: \'ERROR_UPDATING\',\n        ERROR_DELETING: \'ERROR_DELETING\',\n        ERROR_FETCHING: \'ERROR_FETCHING\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When you need to communicate the state of data to your user, you can do it by comparing the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' property of the data to one of the payload states and changing what you render according. I\'ll list the main scenarios below:'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Resolved'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is the ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'static'
	      ),
	      ' state of data, when it exists and is not being acted upon. An example ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: 1,\n        cid: \'c1\',\n        state: \'RESOLVED\',\n        data: {\n          id: 1,\n          title: \'Cornbread is Yummy\'\n        },\n        error: {}\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The fact that ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' has a value tells us this resource exists on the server. And the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' is set to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'RESOLVED'
	      ),
	      ' to signify that this resource is not being modified or deleted.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can also think of resolved resources as the default rendering state, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n        displayName: \'Post\',\n\n        propTypes: {\n          post: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var post = this.props.post;\n\n          return (\n            <div key={post.id} className="post">\n              {post.data.title}\n            </div>\n          );\n        }\n      })\n      ' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Creating'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'An example ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' for a resource being created might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: undefined,\n        cid: \'c1\',\n        state: \'CREATING\',\n        data: {\n          title: \'Cornbread is Yummy\'\n        },\n        error: {}\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' is undefined because the resource doesn\'t exist on the server yet. The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' field contains whatever properties were sent to the server. And the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' is set to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'CREATING'
	      ),
	      ' to signify that this resource is in the process of being created.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When rendering a resource being created, it\'s recommended that you modifying the styling or content of the component to provide a visual indication of this state to the user. If you\'re rendering a list of components and need to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'key'
	      ),
	      'to avoid React warnings you can use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ' property.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          posts: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.CREATING) {\n            return (\n              <div key={post.cid} className="post creating">\n                {post.data.title}\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Updating'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'An example ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' for a resource being updated might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: 1,\n        cid: \'c1\',\n        state: \'UPDATING\',\n        data: {\n          id: 1,\n          title: \'Cornbread is SUPER Yummy\'\n        },\n        error: {}\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' field contains whatever properties were sent to the server, and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' is set to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'UPDATING'
	      ),
	      ' to signify that this resource is in the process of being updated.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When rendering a resource being updated, it\'s recommended that you modifying the styling or content of the component to provide a visual indication of this state to the user.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          posts: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.UPDATING) {\n            return (\n              <div key={post.id} className="post updating">\n                {post.data.title}\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Deleting'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'An example ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' for a resource being deleted might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: 1,\n        cid: \'c1\',\n        state: \'DELETING\',\n        data: {\n          id: 1,\n          title: \'Cornbread is Yummy\'\n        },\n        error: {}\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' is set to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'DELETING'
	      ),
	      ' to signify that this resource is in the process of being deleted.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When rendering a resource being deleting, it\'s recommended that you modifying the styling or content of the component to provide a visual indication of this state to the user.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          posts: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.DELETING) {\n            return (\n              <div key={post.id} className="post deleting">\n                {post.data.title}\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Fetching'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'An example ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' for a resource being fetched might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: 1,\n        cid: \'c1\',\n        state: \'FETCHING\',\n        data: {},\n        error: {}\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' field is empty because the server\'s response is used to populate it, and all we know right now is the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      'of the resource we want to fetch. The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' is set to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'FETCHING'
	      ),
	      ' to signify that this resource is in the process of being fetched.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When rendering a resource being fetched, it\'s recommended that you modifying the styling or content of the application to provide a visual indication of this state to the user.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          posts: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.FETCHING) {\n            return (\n              <div>\n                Loading post...\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Error Creating'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When there is an error creating a resource the data structure might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: undefined,\n        cid: \'c1\',\n        state: \'ERROR_CREATING\',\n        data: {\n          title: \'Cornbread is Yummy\'\n        },\n        error: {\n          statusCode: 409,\n          message: \'Title already exists\'\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' will be updated to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'ERROR_CREATING'
	      ),
	      ', letting us know that we were ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'trying'
	      ),
	      ' to create this resource but something went wrong. The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'error'
	      ),
	      ' field will be populated with whatever error message the server communicates back.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When rendering a resource with an error, it\'s recommended that you modifying the styling or content of the component to provide a visual indication of this state to the user.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          posts: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.ERROR_CREATING) {\n            return (\n              <div key={post.cid} className="post">\n                <span className="error">\n                  {post.error.message}\n                </span>\n                {post.data.title}\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Error Updating'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When there is an error creating a resource the data structure might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: 1,\n        cid: \'c1\',\n        state: \'ERROR_UPDATING\',\n        data: {\n          id: 1,\n          title: \'Cornbread is SUPER Yummy\'\n        },\n        error: {\n          statusCode: 409,\n          message: \'Title already exists\'\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' will be updated to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'ERROR_UPDATING'
	      ),
	      ', letting us know that we were ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'trying'
	      ),
	      ' to update this resource but something went wrong. The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'error'
	      ),
	      ' field will be populated with whatever error message the server communicates back.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When rendering a resource with an error, it\'s recommended that you modifying the styling or content of the component to provide a visual indication of this state to the user.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          posts: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.ERROR_UPDATING) {\n            return (\n              <div key={post.id} className="post">\n                <span className="error">\n                  {post.error.message}\n                </span>\n                {post.data.title}\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Error Deleting'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When there is an error creating a resource the data structure might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: 1,\n        cid: \'c1\',\n        state: \'ERROR_DELETING\',\n        data: {\n          id: 1,\n          title: \'Cornbread is SUPER Yummy\'\n        },\n        error: {\n          statusCode: 403,\n          message: \'Not authorized\'\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' will be updated to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'ERROR_DELETING'
	      ),
	      ', letting us know that we were ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'trying'
	      ),
	      ' to delete this resource but something went wrong. The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'error'
	      ),
	      ' field will be populated with whatever error message the server communicates back.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When rendering a resource with an error, it\'s recommended that you modifying the styling or content of the component to provide a visual indication of this state to the user.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          posts: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.ERROR_DELETING) {\n            return (\n              <div key={post.id} className="post">\n                <span className="error">\n                  {post.error.message}\n                </span>\n                {post.data.title}\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Error Fetching'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When there is an error creating a resource the data structure might look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      post = {\n        id: 1,\n        cid: \'c1\',\n        state: \'ERROR_FETCHING\',\n        data: {},\n        error: {\n          statusCode: 403,\n          message: \'Not authorized\'\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' will be updated to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'ERROR_FETCHING'
	      ),
	      ', letting us know that we were ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'trying'
	      ),
	      ' to fetch this resource but something went wrong. The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'error'
	      ),
	      ' field will be populated with whatever error message the server communicates back.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When rendering a resource with an error, it\'s recommended that you modifying the styling or content of the component to provide a visual indication of this state to the user.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          posts: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.ERROR_FETCHING) {\n            return (\n              <div className="error">\n                Error fetching post :(\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-visual-cues-js-00b6968b22df24c64919.js